const state = new WeakMap();

/** @param {HTMLElement} el */
export const resetBodyScroll = (el = document.documentElement) => {
  state.delete(el);
  el.classList.toggle('_overflow-hidden', false);
  if (el === document.documentElement) document.documentElement.style.paddingRight = '';
};

/** @param {HTMLElement} el */
export const disableBodyScroll = (el = document.documentElement) => {
  let count = state.get(el);

  if (count > 0) {
    state.set(el, count + 1);
  } else {
    state.set(el, 1);
    
    if (el === document.documentElement) {
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
      console.log(window.innerWidth, document.documentElement.clientWidth);
      
      document.documentElement.style.paddingRight = `${scrollWidth}px`;
    }
    el.classList.toggle('_overflow-hidden', true);
  }
};

/** @param {HTMLElement} el */
export const enableBodyScroll = (el = document.documentElement) => {
  let count = state.get(el);

  if (!count) {
    resetBodyScroll(el);
    return;
  }
  
  if (count > 0) state.set(el, --count);

  if (count === 0) {
    el.classList.toggle('_overflow-hidden', false);
    if (el === document.documentElement) document.documentElement.style.paddingRight = '';
  }
};
